module.exports = __webpack_public_path__ + "static/media/tired_man.db644026.png";